// import React from "react";
// import { Grid } from "@mui/material";
// import { BarChart, Users, Sprout, Building2 } from "lucide-react";
// import "./Dashboard.css";
// import { useOverallDashboard } from "../hooks/dashboard/useOverallDashboard";

// const Dashboard = () => {
//   const { dashboardData, loading, error } = useOverallDashboard();

//   // Map API data to stats cards
//   const stats = dashboardData
//     ? [
//         {
//           title: "Total Projects",
//           value: dashboardData.overall_stats.projects.total.toString(),
//           icon: <BarChart size={24} color="white" />,
//           colorClass: "summary-card--blue",
//         },
//         {
//           title: "Active Users",
//           value: dashboardData.overall_stats.users.active.toLocaleString(),
//           icon: <Users size={24} color="white" />,
//           colorClass: "summary-card--green",
//         },
//         {
//           title: "Trees Mapped",
//           value: dashboardData.overall_stats.tree_surveys.total.toLocaleString(),
//           icon: <Sprout size={24} color="white" />,
//           colorClass: "summary-card--teal",
//         },
//         {
//           title: "Organizations",
//           value: dashboardData.overall_stats.organizations.total.toString(),
//           icon: <Building2 size={24} color="white" />,
//           colorClass: "summary-card--purple",
//         },
//       ]
//     : [];

//   // Map API data to projects
//   const projects = dashboardData
//     ? dashboardData.top_projects.map((proj) => ({
//         name: proj.name,
//         location: "Unknown",
//         status: proj.status || "Active",
//         statusColor: proj.status === "active" ? "status-active" : "status-inactive",
//         area: "N/A",
//         planned: proj.tree_count || 0,
//         planted: proj.tree_count || 0,
//         progress: proj.tree_count ? Math.min((proj.tree_count / 1000) * 100, 100) : 0,
//       }))
//     : [];

//   // Map API data to activities
//   const activities = dashboardData
//     ? dashboardData.recent_activity.map((act) => ({
//         user: "Unknown User",
//         action: act.title,
//         project: act.description.split(" ")[2] || "Unknown Project",
//         status: act.action_type === "project" ? "Active" : "Completed",
//         statusColor: act.action_type === "project" ? "status-active" : "status-completed",
//         time: new Date(act.timestamp).toLocaleString(),
//         initials: "NA",
//       }))
//     : [];

//   return (
//     <div className="dashboard-page">
//       {/* Header */}
//       <div className="page-header">
//         <div className="header-content">
//           <h1 className="page-title">Dashboard</h1>
//           <p className="page-subtitle">
//             Welcome back! Here's an overview of your tree geotagging projects and activities.
//           </p>
//         </div>
//       </div>

//       {/* Summary Cards */}
//       <div className="summary-section">
//         {stats.map((stat, index) => (
//           <div key={index} className={`summary-card ${stat.colorClass}`}>
//             <div className="summary-card__icon">{stat.icon}</div>
//             <div className="summary-card__content">
//               <div className="summary-card__title">{stat.title}</div>
//               <div className="summary-card__value">{stat.value}</div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Loading and Error States */}
//       {loading && <div className="loading-state">Loading dashboard...</div>}
//       {error && <div className="error-state">{error}</div>}

//       {/* Project & Activity Sections */}
//       {!loading && !error && (
//         <div className="dash-table-container">
//           <Grid container spacing={3}>
//             {/* Project Overview Table */}
//             <Grid item xs={12} md={20}>
//               <div className="section-card">
//                 <div className="section-header">
//                   <h2 className="section-title">Project Overview</h2>
//                 </div>
//                 {projects.length > 0 ? (
//                   <table className="dash-users-table">
//                     <thead>
//                       <tr>
//                         <th>Project</th>
//                         <th>Location</th>
//                         <th>Status</th>
//                         <th>Area</th>
//                         <th>Planned</th>
//                         <th>Planted</th>
//                         <th>Progress</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {projects.map((proj, index) => (
//                         <tr key={index} className="table-row">
//                           <td>
//                             <div className="user-info">
//                               <div className="user-avatar" style={{ backgroundColor: "#3b82f6" }}>
//                                 {proj.name?.[0] || "P"}
//                               </div>
//                               <div className="user-details">
//                                 <div className="user-name">{proj.name}</div>
//                                 <div className="user-email">{proj.location}</div>
//                               </div>
//                             </div>
//                           </td>
//                           <td>{proj.location}</td>
//                           <td>
//                             <span className={`status-badge ${proj.statusColor}`}>
//                               {proj.status}
//                             </span>
//                           </td>
//                           <td>{proj.area}</td>
//                           <td>{proj.planned}</td>
//                           <td>{proj.planted}</td>
//                           <td>
//                             <div className="progress-bar">
//                               <div
//                                 className="progress-fill"
//                                 style={{ width: `${proj.progress}%` }}
//                               ></div>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 ) : (
//                   <div className="empty-state">
//                     <svg viewBox="0 0 24 24" className="empty-icon" fill="#6b7280">
//                       <path d="M12 12c2.21 0 4-1.79 4-4S14.21 4 12 4 8 5.79 8 8s1.79 4 4 4zm0 2c-3.33 0-10 1.67-10 5v3h20v-3c0-3.33-6.67-5-10-5z" />
//                     </svg>
//                     <h3>No projects found</h3>
//                     <p>No projects available at this time.</p>
//                   </div>
//                 )}
//               </div>
//             </Grid>

//             {/* Recent Activity Table */}
//             <Grid item xs={12} md={6}>
//               <div className="section-card">
//                 <div className="section-header">
//                   <h2 className="section-title">Recent Activity</h2>
//                 </div>
//                 {activities.length > 0 ? (
//                   <table className="users-table">
//                     <thead>
//                       <tr>
//                         <th>User</th>
//                         <th>Action</th>
//                         <th>Project</th>
//                         <th>Status</th>
//                         <th>Time</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {activities.map((act, index) => (
//                         <tr key={index} className="table-row">
//                           <td>
//                             <div className="user-info">
//                               <div className="user-avatar" style={{ backgroundColor: "#3b82f6" }}>
//                                 {act.initials}
//                               </div>
//                               <div className="user-details">
//                                 <div className="user-name">{act.user}</div>
//                                 <div className="user-email">{act.project}</div>
//                               </div>
//                             </div>
//                           </td>
//                           <td>{act.action}</td>
//                           <td>{act.project}</td>
//                           <td>
//                             <span className={`status-badge ${act.statusColor}`}>
//                               {act.status}
//                             </span>
//                           </td>
//                           <td className="last-login-cell">{act.time}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 ) : (
//                   <div className="empty-state">
//                     <svg viewBox="0 0 24 24" className="empty-icon" fill="#6b7280">
//                       <path d="M12 12c2.21 0 4-1.79 4-4S14.21 4 12 4 8 5.79 8 8s1.79 4 4 4zm0 2c-3.33 0-10 1.67-10 5v3h20v-3c0-3.33-6.67-5-10-5z" />
//                     </svg>
//                     <h3>No activities found</h3>
//                     <p>No activities available at this time.</p>
//                   </div>
//                 )}
//               </div>
//             </Grid>
//           </Grid>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Dashboard; 


import React from "react";
import { Grid } from "@mui/material";
import { BarChart, Users, Sprout, Building2 } from "lucide-react";
import "./Dashboard.css";
import { useOverallDashboard } from "../../hooks/dashboard/useOverallDashboard";

// Simple hash function for avatar colors
const getAvatarColor = (str = "Project") => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 70%, 55%)`;
};

const Dashboard = () => {
  const { dashboardData, loading, error } = useOverallDashboard();

  const stats = dashboardData
    ? [
        {
          title: "Total Projects",
          value: dashboardData.overall_stats.projects.total.toString(),
          icon: <BarChart size={24} color="white" />,
          colorClass: "summary-card--blue",
        },
        {
          title: "Active Users",
          value: dashboardData.overall_stats.users.active.toLocaleString(),
          icon: <Users size={24} color="white" />,
          colorClass: "summary-card--green",
        },
        {
          title: "Trees Mapped",
          value: dashboardData.overall_stats.tree_surveys.total.toLocaleString(),
          icon: <Sprout size={24} color="white" />,
          colorClass: "summary-card--teal",
        },
        {
          title: "Organizations",
          value: dashboardData.overall_stats.organizations.total.toString(),
          icon: <Building2 size={24} color="white" />,
          colorClass: "summary-card--purple",
        },
      ]
    : [];

  const projects = dashboardData
    ? dashboardData.top_projects.map((proj) => ({
        ...proj,
        location: proj.location || "—",
        status: proj.status || "Active",
        statusColor: proj.status?.toLowerCase() === "active" ? "status-active" : "status-inactive",
        area: proj.area_ha ? `${proj.area_ha} ha` : "—",
        planned: proj.planned_count || proj.tree_count || 0,
        planted: proj.planted_count || proj.tree_count || 0,
        progress: proj.target_count
          ? Math.min((proj.planted_count / proj.target_count) * 100, 100)
          : proj.tree_count
          ? Math.min((proj.tree_count / 1000) * 100, 100)
          : 0,
      }))
    : [];

  const activities = dashboardData
    ? dashboardData.recent_activity.map((act) => ({
        ...act,
        user: act.user || "System",
        initials: (act.user?.[0] || "S").toUpperCase(),
        project: act.project || act.description?.split(" ")[2] || "—",
        status: act.action_type === "project" ? "Active" : "Completed",
        statusColor: act.action_type === "project" ? "status-active" : "status-completed",
        time: new Date(act.timestamp).toLocaleString([], {
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }),
      }))
    : [];

  // Example navigation handler - replace with your actual router
  const handleProjectClick = (projectId) => {
    console.log(`Navigate to project: ${projectId}`);
    // navigate(`/projects/${projectId}`);
  };

  return (
    <div className="dashboard-page">
      {/* Header */}
      <header className="page-header">
        <h1 className="page-title">Dashboard</h1>
        <p className="page-subtitle">
          Overview of your tree geotagging projects and recent activities
        </p>
      </header>

      {/* Summary Cards */}
      <section className="summary-section">
        {loading
          ? Array(4)
              .fill(0)
              .map((_, i) => <div key={i} className="summary-card skeleton-card" />)
          : stats.map((stat, index) => (
              <div key={index} className={`summary-card ${stat.colorClass}`}>
                <div className="summary-card__icon">{stat.icon}</div>
                <div className="summary-card__content">
                  <div className="summary-card__title">{stat.title}</div>
                  <div className="summary-card__value">{stat.value}</div>
                </div>
              </div>
            ))}
      </section>

      {/* Main Content */}
      {error && <div className="error-state">{error}</div>}

      {!error && (
        <div className="dashboard-grid">
          {/* Main Column - Projects */}
          <div className="main-column">
            <div className="section-card">
              <h2 className="section-title">Project Overview</h2>

              {loading ? (
                <div className="skeleton-container">
                  {Array(5)
                    .fill(0)
                    .map((_, i) => (
                      <div key={i} className="skeleton-row" />
                    ))}
                </div>
              ) : projects.length > 0 ? (
                <table className="dash-table">
                  <thead>
                    <tr>
                      <th>Project</th>
                      <th>Location</th>
                      <th>Status</th>
                      <th>Area</th>
                      <th>Planned</th>
                      <th>Planted</th>
                      <th>Progress</th>
                    </tr>
                  </thead>
                  <tbody>
                    {projects.map((proj, index) => (
                      <tr
                        key={index}
                        className="table-row"
                        onClick={() => handleProjectClick(proj.id || index)}
                        role="link"
                        tabIndex={0}
                      >
                        <td>
                          <div className="user-info">
                            <div
                              className="user-avatar"
                              style={{ backgroundColor: getAvatarColor(proj.name) }}
                            >
                              {proj.name?.[0]?.toUpperCase() || "P"}
                            </div>
                            <div className="user-details">
                              <div className="user-name">{proj.name}</div>
                            </div>
                          </div>
                        </td>
                        <td>{proj.location}</td>
                        <td>
                          <span className={`status-badge ${proj.statusColor}`}>
                            {proj.status}
                          </span>
                        </td>
                        <td>{proj.area}</td>
                        <td>{proj.planned.toLocaleString()}</td>
                        <td>{proj.planted.toLocaleString()}</td>
                        <td>
                          <div className="progress-bar">
                            <div
                              className="progress-fill"
                              style={{ width: `${proj.progress}%` }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="empty-state">No projects found</div>
              )}
            </div>
          </div>

          {/* Side Column - Recent Activity */}
          <div className="side-column">
            <div className="section-card">
              <h2 className="section-title">Recent Activity</h2>

              {loading ? (
                <div className="skeleton-container">
                  {Array(6)
                    .fill(0)
                    .map((_, i) => (
                      <div key={i} className="skeleton-row" />
                    ))}
                </div>
              ) : activities.length > 0 ? (
                <table className="dash-table activity-table">
                  <tbody>
                    {activities.map((act, index) => (
                      <tr key={index} className="table-row">
                        <td>
                          <div className="user-info">
                            <div
                              className="user-avatar"
                              style={{ backgroundColor: getAvatarColor(act.user) }}
                            >
                              {act.initials}
                            </div>
                            <div className="user-details">
                              <div className="user-name">{act.user}</div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="activity-action">{act.action}</div>
                          <div className="activity-project">{act.project}</div>
                        </td>
                        <td>
                          <span className={`status-badge ${act.statusColor}`}>
                            {act.status}
                          </span>
                        </td>
                        <td className="activity-time">{act.time}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="empty-state">No recent activity</div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;